/**
 * Form's views: handle template, fieldstypes operations
 * Path: `@/views/form`
 */

import multiguard from "vue-router-multiguard"
import { requireAuth, requireCompany } from "@/utils/middleware"

const FieldTypeEditor = () => import("@/views/form/FieldTypeEditor.vue")
const InspectionDocumentEditorView = () => import("@/views/form/InspectionDocumentEditorView.vue")
const TemplateEditorView = () => import("@/views/form/TemplateEditorView.vue")
const TemplateList = () => import("@/views/form/TemplateList.vue")
const TemplateDrawer = () => import("@/components/layouts/core/TemplateDrawer.vue")

export default [
  {
    path: "/forms",
    redirect: { name: "TemplateList" }
  },
  {
    path: "/forms/fieldtypes",
    name: "FieldTypeEditor",
    component: FieldTypeEditor,
    beforeEnter: multiguard([requireAuth, requireCompany]),
    meta: {
      layout: "default",
      drawer: TemplateDrawer
    }
  },
  {
    path: "/projects/inspections/document",
    name: "InspectionDocumentEditorView",
    component: InspectionDocumentEditorView,
    props: true,
    beforeEnter: multiguard([requireAuth, requireCompany]),
    meta: {
      layout: "default"
    }
  },
  {
    path: "/forms/templates",
    name: "TemplateList",
    component: TemplateList,
    beforeEnter: multiguard([requireAuth, requireCompany]),
    meta: {
      layout: "default",
      drawer: TemplateDrawer
    }
  },
  {
    path: "/forms/templates/:id",
    name: "TemplateEditorView",
    component: TemplateEditorView,
    beforeEnter: multiguard([requireAuth, requireCompany]),
    meta: {
      layout: "default"
    }
  }
]
